import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "source", "copyLink"];

  declare sourceTarget: HTMLElement;
  declare copyLinkTarget: HTMLButtonElement;

  async copy(event: Event) {
    event.preventDefault();
    try {
      await navigator.clipboard.writeText((this.sourceTarget.textContent || "").trim());
      this.flashMessage();
    } catch (err) {
      console.error("Could not copy text: ", err);
    }
  }

  flashMessage() {
    const iconElement = this.copyLinkTarget.querySelector(".fas");
    iconElement?.classList?.remove("fa-copy");
    iconElement?.classList?.add("fa-check");
    this.copyLinkTarget.setAttribute("aria-disabled", "true");
    this.copyLinkTarget.disabled = true;
    setTimeout(() => {
      iconElement?.classList?.remove("fa-check");
      iconElement?.classList?.add("fa-copy");
      this.copyLinkTarget.removeAttribute("aria-disabled");
      this.copyLinkTarget.disabled = false;
    }, 2000);
  }
}
